// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"40":"censoautomotriz-dashboard","853":"verificacion-dashboard","966":"dashboard"}[chunkId] + "." + {"40":"0cc55544","853":"d6218187","966":"8ecc8c28"}[chunkId] + ".css";
};